import { useSendEmailVerificationEmailMutation } from 'src/graphql/generated';

export const useResendVerificationEmail = () => {
  const [mutate, { data, loading, error }] =
    useSendEmailVerificationEmailMutation();

  return { mutate, data, loading, error };
};
